import React from "react"
import BlogTexto from "./blog/texto"
import BlogImagen from "./blog/imagen"
import BlogImagenDoble from "./blog/imagenDoble"
import BlogYouTubeVideo from "./blog/youtubeVideo"
import BlogDescargaPdfPw from "./blog/descargaPdfPw"

const ContentBlog = ({ contents, isMounting, isExiting, pageRuta }) => {
  const itemProps = {
    isMounting: isMounting,
    isExiting: isExiting,
    pageRuta: pageRuta,
  }
  let result = []
  contents.forEach((content, i) => {
    switch (content.type) {
      case "texto":
        result.push(
          <BlogTexto key={i} order={i} content={content} {...itemProps} />
        )
        break
      case "imagen":
        result.push(
          <BlogImagen key={i} order={i} content={content} {...itemProps} />
        )
        break
      case "imagendoble":
        result.push(
            <BlogImagenDoble key={i} order={i} content={content} {...itemProps} />
        )
        break
      case "youtubevideo":
        result.push(
          <BlogYouTubeVideo
            key={i}
            order={i}
            content={content}
            {...itemProps}
          />
        )
        break
      case "descarga_pdf":
        result.push(
          <BlogDescargaPdfPw
            key={i}
            order={i}
            content={content}
            {...itemProps}
          />
        )
        break
      default:
        break
    }
  })
  return result
}

export default ContentBlog
